import React from "react";
import { Box, Typography } from "@mui/material";
import { GaImage } from "../../components/ui/GaImage";

const storyButtonSx = {
  border: 0,
  p: 0,
  m: 0,
  bgcolor: "transparent",
  color: "inherit",
  font: "inherit",
  cursor: "pointer",
  textAlign: "center",
  minWidth: { xs: 64, md: 88, lg: 104 },
  WebkitTapHighlightColor: "transparent",
  userSelect: "none",
  outline: "none",
  boxShadow: "none",
  appearance: "none",
  "&, & *": {
    WebkitTapHighlightColor: "transparent",
    outline: "none",
  },
  "&:hover, &:focus, &:focus-visible, &:active": {
    outline: "none",
    bgcolor: "transparent",
    boxShadow: "none",
  },
};

export function StoryBubble({ title, thumbnail, eager, onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onMouseDown={(event) => event.preventDefault()}
      onClick={onClick}
      sx={storyButtonSx}
    >
      <Box
        sx={{
          width: { xs: 64, md: 88, lg: 104 },
          height: { xs: 64, md: 88, lg: 104 },
          borderRadius: "50%",
          background: "linear-gradient(180deg, #D8F23B, #FCA01F)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "calc(100% - 4px)",
            height: "calc(100% - 4px)",
            borderRadius: "50%",
            backgroundColor: "#0D0F0A",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "calc(100% - 6px)",
              height: "calc(100% - 6px)",
              borderRadius: "50%",
              overflow: "hidden",
              aspectRatio: "1 / 1",
            }}
          >
            <GaImage
              src={thumbnail}
              alt=""
              eager={Boolean(eager)}
              width={104}
              height={104}
              sx={{
                width: "100%",
                height: "100%",
                aspectRatio: "1 / 1",
                objectFit: "cover",
                pointerEvents: "none",
                WebkitTapHighlightColor: "transparent",
                bgcolor: "#0D0F0A",
              }}
            />
          </Box>
        </Box>
      </Box>
      <Typography
        sx={{
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          fontSize: 12,
          color: "#FFFFFF",
          mt: "8px",
          lineHeight: 1,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
